if (!customElements.get('ss-infinite-scroll')) {
  class SSInfiniteScroll extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;

      this.grid = this.closest('.collection')?.querySelector('#product-grid');
      if (!this.grid || !this.dataset.nextUrl) return;

      this.observer = new IntersectionObserver((entries) => {
        if (entries[0]?.isIntersecting) this.loadNextPage();
      }, { rootMargin: '0px 0px 400px 0px' });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }

    async loadNextPage() {
      if (this.loading || !this.dataset.nextUrl) return;

      this.loading = true;
      this.dataset.loading = 'true';
      this.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(new URL(this.dataset.nextUrl, window.location.origin));
        if (!response.ok) throw new Error(`Unable to load products (${response.status})`);

        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = page.querySelector('#product-grid');
        if (!nextGrid) throw new Error('Product grid was not found in the response');

        const products = Array.from(nextGrid.children);
        this.grid.append(...products);

        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(this.grid);
        }

        const nextScroller = page.querySelector('ss-infinite-scroll');
        const nextUrl = nextScroller?.dataset.nextUrl;

        if (nextUrl) {
          this.dataset.nextUrl = nextUrl;
        } else {
          this.finish();
        }
      } catch (error) {
        console.error('Infinite scroll:', error);
        this.showRetry();
      } finally {
        this.loading = false;
        delete this.dataset.loading;
        this.removeAttribute('aria-busy');
      }
    }

    finish() {
      this.observer?.disconnect();
      this.remove();
    }

    showRetry() {
      this.observer?.disconnect();

      const retry = document.createElement('a');
      retry.className = 'ss-infinite-scroll__retry link underlined-link';
      retry.href = this.dataset.nextUrl;
      retry.textContent = this.dataset.retryText || 'Load more';
      retry.addEventListener('click', (event) => {
        event.preventDefault();
        retry.remove();
        this.observer?.observe(this);
        this.loadNextPage();
      });

      this.append(retry);
    }
  }

  customElements.define('ss-infinite-scroll', SSInfiniteScroll);
}
